/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

import { useLocation, useNavigate } from "react-router-dom";

import AddCharges from "../../Modals/addChargesModal";
import RefundModal from "../../Modals/refundModal";

type OfferTableProps = {
  actionType?: "active" | "scheduled" | "expired" | "quick";
  category?: string;
};

const CancelTable = ({ actionType = "quick", category = "All" }: OfferTableProps) => {

  const navigate = useNavigate();
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const allRows = [
    {
      id: 1,
      OfferName: "The Residence Tunis",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      ClientName: "John Smith",
      ClientEmail: "john@gmail.com",
      ClientPhone: "+971 (0) 567894623",
      internalStatus: "Pending",
      EmployeeName: "John Smith",
      Category: "Dining",
    },
    {
      id: 2,
      OfferName: "The Residence Tunis",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      ClientName: "Jane Doe",
      ClientEmail: "jane@gmail.com",
      ClientPhone: "+971 (0) 567894624",
      internalStatus: "Completed",
      EmployeeName: "John Smith",
      Category: "Event",
    },
    {
      id: 3,
      OfferName: "The Residence Tunis",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      ClientName: "Jane Doe",
      ClientEmail: "jane@gmail.com",
      ClientPhone: "+971 (0) 567894624",
      internalStatus: "Completed",
      EmployeeName: "John Smith",
      Category: "Experience",
    },
    {
      id: 4,
      OfferName: "The Residence Tunis",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      ClientName: "Jane Doe",
      ClientEmail: "jane@gmail.com",
      ClientPhone: "+971 (0) 567894624",
      internalStatus: "Completed",
      EmployeeName: "John Smith",
      Category: "Beach Clubs",
    },
    {
      id: 5,
      OfferName: "The Residence Tunis",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      ClientName: "Jane Doe",
      ClientEmail: "jane@gmail.com",
      ClientPhone: "+971 (0) 567894624",
      internalStatus: "Completed",
      EmployeeName: "John Smith",
      Category: "Benefits",
    },
    {
      id: 6,
      OfferName: "The Residence Tunis",
      BookingTime: "2nd-June-2025 | 6:00PM",
      Guests: "04",
      ClientName: "Jane Doe",
      ClientEmail: "jane@gmail.com",
      ClientPhone: "+971 (0) 567894624",
      internalStatus: "Completed",
      EmployeeName: "John Smith",
      Category: "Wellness",
    },
  ];

  const rows = category === "All" ? allRows : allRows.filter(row => row.Category === category);

  const toggleExpand = (id: number) => {
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };
  const [Employee, setEmployee] = React.useState("0");
  const handleChange1 = (event: SelectChangeEvent) => {
    setEmployee(event.target.value as string);
  };
  const [Status, setStatus] = React.useState("0");
  const handleChange2 = (event: SelectChangeEvent) => {
    setStatus(event.target.value as string);
  };
  const [open, setOpen] = useState(false);
  const handleCloseModal = () => {
    setOpen(false);
  };
  const [open1, setOpen1] = useState(false);
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const [acceptedRows, setAcceptedRows] = useState<Record<number, boolean>>({});
  const [paidOption, setPaidOption] = useState("");

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");

  return (
    <>
      <div className="table_container">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>Booking ID</th>
              <th>Offer Name</th>
              <th>Booking Time</th>
              <th>Guests</th>
              <th>Category</th>
              <th>Employee Name</th>
              <th>Client Name</th>

              <th>Internal Status</th>


            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <React.Fragment key={row.id}>
                <tr>
                  <td>{row.id}</td>
                  <td
                    className="cursor_p max_c2"
                    onClick={() =>
                      navigate(`/manage-booking-resvp/booking-detail?category=${row.Category}`,{state:{count:row.Guests,cancel:true}})
                    }
                  >
                    {" "}
                    <p> {row.OfferName}</p>
                  </td>
                  <td className="max_c2" >
                    {" "}
                    <p className="text_btn cursor_p" onClick={() => toggleExpand(row.id)}> {row.BookingTime}</p>{" "}
                  </td>
                  <td>{row.Guests}</td>
                  <td>{row.Category}</td>
                  <td>{row.EmployeeName}</td>

                  <td className="max_c2">{row.ClientName}
                    <p> {row.ClientPhone}</p>
                  </td>

                  <td>{row.internalStatus}</td>


                </tr>

                {expandedRowId === row.id && (
                  <tr>
                    <td colSpan={8}>
                      <div className="expanded-content">
                        
                        <div className="form_flex">
                          <div className="w_100">
                            <div className="control_group employee_list  mb_0">
                              <Select value={Employee} onChange={handleChange1}>
                                <MenuItem value={0} disabled>
                                  Employee Listing
                                </MenuItem>
                                <MenuItem value={10}>Adam Smith</MenuItem>
                                <MenuItem value={20}>Denny Juan</MenuItem>
                                <MenuItem value={30}>Hermanto</MenuItem>
                              </Select>
                            </div>

                            <Select
                              value={Status}
                              onChange={handleChange2}
                              className="booking_status"
                            >
                              <MenuItem value={0} disabled>
                                Status
                              </MenuItem>
                              <MenuItem value={10}>New</MenuItem>
                              <MenuItem value={20}>In Progress</MenuItem>
                              <MenuItem value={30}>Pending Venue</MenuItem>
                              <MenuItem value={40}>Pending Member</MenuItem>
                              <MenuItem value={50}>Cancelled</MenuItem>
                            </Select>
                            <div className="control_group add_note">
                              <TextField
                                placeholder="Add Notes"
                                hiddenLabel
                                fullWidth
                              ></TextField>
                            </div>
                            <Button className="btn btn_primary">Save</Button>
                            <Button
                              className="btn btn_primary"
                              onClick={() =>
                                setAcceptedRows((prev) => ({
                                  ...prev,
                                  [row.id]: true,
                                }))
                              }
                            >
                              Accept
                            </Button>

                          </div>
                          <div className="w_100">
                            <FormControlLabel
                              control={<Checkbox />}
                              label="Assign to me"
                            />

                            {acceptedRows[row.id] && row.Category === "Dining" && (
                              <>
                                <div className="control_group charge_field">
                                  <h2>Do you want to charge?</h2>
                                </div>
                                <div className="control_group ">
                                  <FormControl className="paid_radio">
                                    <RadioGroup
                                      aria-labelledby="demo-radio-buttons-group-label"
                                      defaultValue="female"
                                      name="radio-buttons-group"
                                      value={paidOption}
                                      onChange={(e) =>
                                        setPaidOption(e.target.value)
                                      }
                                    >
                                      <FormControlLabel
                                        value="yes"
                                        control={<Radio />}
                                        label="Yes"
                                      />
                                      <FormControlLabel
                                        value="no"
                                        control={<Radio />}
                                        label="No"
                                      />
                                    </RadioGroup>
                                  </FormControl>
                                </div>
                                {paidOption === "yes" && (
                                  <div className="control_group default_charge_field">
                                    <TextField
                                      placeholder="AED 4000"
                                      hiddenLabel
                                      fullWidth
                                    ></TextField>
                                  </div>
                                )}
                              </>
                            )}

                            {acceptedRows[row.id] && row.Category === "Event" && (
                              <>
                                <div className="control_group charge_field">
                                  <h2>Do you want to refund?</h2>
                                </div>
                                <div className="control_group">
                                  {mode === "refunded" ? (
                                    <>
                                      <Button className="btn btn_primary"
                                        onClick={() =>
                                          navigate(`/manage-booking-resvp/booking-detail?category=${row.Category}`)
                                        }>Refunded</Button>
                                    </>
                                  ) : (
                                    <>
                                      <FormControl className="paid_radio">
                                        <RadioGroup
                                          aria-labelledby="demo-radio-buttons-group-label"
                                          name="radio-buttons-group"
                                        >
                                          <FormControlLabel value="yes" control={<Radio />} label="Yes" onClick={() => setOpen1(true)} />
                                          <FormControlLabel value="no" control={<Radio />} label="No" />
                                        </RadioGroup>
                                      </FormControl>
                                    </>
                                  )}

                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
      <AddCharges open={open} onClose={handleCloseModal} setOpen={setOpen} />
      <RefundModal open={open1} onClose={handleCloseModal1} setOpen={setOpen1} />
    </>
  );
};

export default CancelTable;
